(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Find header - try multiple selectors and methods for collection pages
      this.header = document.querySelector('.shopify-section-header');
      
      // Fallback: find by section id if direct query fails (for collection pages)
      if (!this.header) {
        const headerSection = document.querySelector('[id^="shopify-section-header"]');
        if (headerSection && headerSection.classList.contains('shopify-section-header')) {
          this.header = headerSection;
        }
      }
      
      // Additional fallback: find any element with shopify-section-header class
      if (!this.header) {
        this.header = document.querySelector('[class*="shopify-section-header"]');
      }

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      // Ensure header reference is set (important for collection pages)
      if (!this.header) {
        this.header = document.querySelector('.shopify-section-header');
      }

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
      
      // Run initial scroll check immediately (important for collection pages that may load scrolled)
      // Use setTimeout to ensure DOM is ready
      setTimeout(() => {
        if (this.header) {
          this.onScroll();
        }
      }, 0);
      
      // Check initial scroll position for desktop menu state
      // Use multiple delays for collection pages where layout might change
      const initScrollState = () => {
        if (!this.header) return;
        
        if (window.innerWidth >= 990) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (scrollTop > 50) {
            this.header.classList.add('header-scrolled');
          }
        }
      };
      
      initScrollState();
      setTimeout(initScrollState, 100);
      setTimeout(initScrollState, 500); // Extra delay for collection pages
      
      // Re-initialize on collection page reload events
      document.addEventListener('collection:reloaded', () => {
        // Re-find header in case DOM changed
        this.header = document.querySelector('.shopify-section-header');
        setTimeout(() => {
          if (this.header) {
            this.createObserver();
            initScrollState();
            // Force initial scroll check for collection pages
            this.onScroll();
          }
        }, 200);
      });
      
      // Also listen for shopify:section:load (theme editor and AJAX navigation)
      document.addEventListener('shopify:section:load', (event) => {
        // If header section was reloaded, re-initialize
        if (event.detail && event.detail.sectionId && event.detail.sectionId.includes('header')) {
          setTimeout(() => {
            this.header = document.querySelector('.shopify-section-header');
            if (this.header) {
              this.createObserver();
              initScrollState();
              this.onScroll();
            }
          }, 100);
        }
      });
      
      // Immediate scroll check on load (important for collection pages that load with scroll position)
      window.addEventListener('load', () => {
        setTimeout(() => {
          if (this.header) {
            this.onScroll();
          }
        }, 100);
      });
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      // Set initial bounds immediately (important for collection pages where observer might not fire)
      if (this.header) {
        const rect = this.header.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        this.headerBounds = {
          top: scrollTop + rect.top,
          bottom: scrollTop + rect.bottom
        };
      }
      
      let observer = new IntersectionObserver((entries, observer) => {
        if (entries[0]) {
          this.headerBounds = entries[0].intersectionRect;

          // If bounds are invalid, calculate from boundingClientRect
          if (!this.headerBounds || (this.headerBounds.top === 0 && this.headerBounds.bottom === 0)) {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const boundingClientRect = entries[0].boundingClientRect;

            if (boundingClientRect) {
              this.headerBounds = {
                top: scrollTop + boundingClientRect.top,
                bottom: scrollTop + boundingClientRect.bottom
              };
            } else if (this.header) {
              // Ultimate fallback: use getBoundingClientRect
              const rect = this.header.getBoundingClientRect();
              this.headerBounds = {
                top: scrollTop + rect.top,
                bottom: scrollTop + rect.bottom
              };
            }
          }
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      if (this.header) {
        observer.observe(this.header);
      }
      
      // Recalculate bounds after a delay (for collection pages where layout might change)
      setTimeout(() => {
        if (this.header) {
          const rect = this.header.getBoundingClientRect();
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          this.headerBounds = {
            top: scrollTop + rect.top,
            bottom: scrollTop + rect.bottom
          };
        }
      }, 300);
    }

    onScroll() {
      // Re-find header if missing (collection pages might reload DOM)
      if (!this.header) {
        this.header = document.querySelector('.shopify-section-header');
      }
      
      // Early exit only if we truly can't find header - but try desktop logic first
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const isDesktop = window.innerWidth >= 990;
      
      // Desktop menu visibility logic - run FIRST (critical for collection pages)
      // This ensures it runs even if other conditions fail
      if (isDesktop && this.header) {
        if (scrollTop > 50) {
          this.header.classList.add('header-scrolled');
          // Ensure sticky is active
          if (!this.header.classList.contains('shopify-section-header-sticky')) {
            this.header.classList.add('shopify-section-header-sticky');
            document.body.classList.add('shopify-body-section-header-sticky');
          }
          // Ensure header is visible (not hidden)
          this.header.classList.remove('shopify-section-header-hidden');
          document.body.classList.remove('shopify-body-section-header-hidden');
        } else {
          this.header.classList.remove('header-scrolled');
          // Only remove menu-open if we're at the top of the page
          if (scrollTop <= (this.headerBounds?.top || 0)) {
            this.header.classList.remove('header-menu-open');
          }
        }
      }
      
      // Now exit if no header found (after desktop logic has run)
      if (!this.header) return;
      
      const isMenuOpen = this.header && this.header.classList.contains('header-menu-open');

      // Don't hide header if menu is open
      if (!isMenuOpen) {
        if (theme.config.mqlSmall || this.scrollUpActive) {
          // Ensure headerBounds exist before using them
          if (!this.headerBounds || !this.headerBounds.bottom) {
            if (this.header) {
              const rect = this.header.getBoundingClientRect();
              const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
              this.headerBounds = {
                top: currentScroll + rect.top,
                bottom: currentScroll + rect.bottom
              };
            }
          }
          
          if (scrollTop > this.currentScrollTop && scrollTop > (this.headerBounds?.bottom || 100)) {
            requestAnimationFrame(this.hide.bind(this));
          }
          else if (scrollTop < this.currentScrollTop && scrollTop > (this.headerBounds?.bottom || 100)) {
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            }
            else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          }
          else if (scrollTop <= (this.headerBounds?.top || 0)) {
            requestAnimationFrame(this.reset.bind(this));
          }
        }
        else {
          // Desktop: Always keep header visible and sticky when scrolled
          // Ensure headerBounds is set (fallback for collection pages where observer might not work)
          if (!this.headerBounds || !this.headerBounds.top || !this.headerBounds.bottom) {
            if (this.header) {
              const rect = this.header.getBoundingClientRect();
              const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
              this.headerBounds = {
                top: currentScroll + rect.top,
                bottom: currentScroll + rect.bottom
              };
            } else {
              // Safe defaults if header not found
              this.headerBounds = { top: 0, bottom: 150 };
            }
          }
          
          const headerTop = this.headerBounds.top || 0;
          
          if (scrollTop <= 0 || scrollTop <= headerTop) {
            // At top of page - reset to normal state (remove sticky)
            requestAnimationFrame(this.reset.bind(this));
          }
          else {
            // Any scroll down from top - ensure sticky is always active and visible
            // Header should stay visible and sticky, only menu items hide
            if (!this.header.classList.contains('shopify-section-header-sticky')) {
              this.header.classList.add('shopify-section-header-sticky');
              document.body.classList.add('shopify-body-section-header-sticky');
            }
            
            // Keep header visible (reveal) - don't hide it on scroll down
            // Only the menu items hide via CSS (header-scrolled class)
            if (this.header.classList.contains('shopify-section-header-hidden')) {
              requestAnimationFrame(this.reveal.bind(this));
            }
          }
        }
      } else {
        // Menu is open - ensure header is visible
        requestAnimationFrame(this.reveal.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      // Don't hide if menu is open
      if (this.header && this.header.classList.contains('header-menu-open')) {
        return;
      }
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  // Global fallback scroll handler for collection pages
  // This ensures header works even if custom element initialization fails
  (function() {
    let lastScrollTop = 0;
    let ticking = false;
    
    function handleGlobalScroll() {
      if (ticking) return;
      
      ticking = true;
      requestAnimationFrame(() => {
        const header = document.querySelector('.shopify-section-header');
        if (!header) {
          ticking = false;
          return;
        }
        
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const isDesktop = window.innerWidth >= 990;
        
        if (isDesktop) {
          if (scrollTop > 0) { /** wedev change - was 50; cased glitching */
            header.classList.add('header-scrolled', 'shopify-section-header-sticky');
            document.body.classList.add('shopify-body-section-header-sticky');
            header.classList.remove('shopify-section-header-hidden');
            document.body.classList.remove('shopify-body-section-header-hidden');
          } else {
            header.classList.remove('header-scrolled');
            if (scrollTop <= 0) {
              header.classList.remove('shopify-section-header-sticky');
              document.body.classList.remove('shopify-body-section-header-sticky');
            }
          }
        }
        
        lastScrollTop = scrollTop;
        ticking = false;
      });
    }
    
    // Add scroll listener with multiple initialization points
    window.addEventListener('scroll', handleGlobalScroll, { passive: true });
    
    // Also trigger on collection reload events
    document.addEventListener('collection:reloaded', () => {
      setTimeout(handleGlobalScroll, 100);
    });
    
    // Initial check
    setTimeout(handleGlobalScroll, 100);
    window.addEventListener('load', () => {
      setTimeout(handleGlobalScroll, 200);
    });
  })();

  // Desktop menu toggle functionality - enhance existing HeaderMenuToggle
  (function() {
    function initDesktopMenuToggle() {
      const headerMenuToggles = document.querySelectorAll('header-menu-toggle.desktop-menu-toggle');
      
      headerMenuToggles.forEach(function(toggle) {
        // Skip if already initialized
        if (toggle.dataset.initialized === 'true') return;
        toggle.dataset.initialized = 'true';
        
        const button = toggle.querySelector('.header__icon--menu');
        const header = document.querySelector('.shopify-section-header');
        
        if (button && header) {
          button.addEventListener('click', function(event) {
            if (window.innerWidth >= 990) { // Desktop only
              event.preventDefault();
              event.stopPropagation();
              
              const isOpening = !header.classList.contains('header-menu-open');
              header.classList.toggle('header-menu-open');
              
              // Ensure header is visible when menu opens
              if (isOpening) {
                // Force reveal to ensure header is visible
                header.classList.remove('shopify-section-header-hidden');
                document.body.classList.remove('shopify-body-section-header-hidden');
                header.classList.add('shopify-section-header-sticky');
                document.body.classList.add('shopify-body-section-header-sticky');
              }
            }
          });
        }
      });
    }
    
    // Run immediately if DOM is ready, otherwise wait
    function initializeToggle() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initDesktopMenuToggle);
      } else {
        initDesktopMenuToggle();
      }
    }
    
    initializeToggle();
    
    // Re-initialize on collection page reload events
    document.addEventListener('collection:reloaded', function() {
      setTimeout(initDesktopMenuToggle, 300);
    });
    
    // Re-initialize after delays for collection pages
    setTimeout(initDesktopMenuToggle, 500);
    setTimeout(initDesktopMenuToggle, 1000);
  })();

  } catch(e) { console.error(e); }
})();
})();
